var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"statePage"},[(_vm.stateContent)?[_c('p',{staticClass:"stateTitle textCenter"},[_vm._v(_vm._s(_vm.stateContent.name))]),_c('div',{staticClass:"stateContent baseFour",domProps:{"innerHTML":_vm._s(_vm.stateContent.ext.disclaimers)}})]:_c('el-empty',{attrs:{"description":"暂未设置免责声明"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }